function StepCompleted(props) {
  return null;
}
StepCompleted.displayName = "@mantine/core/StepCompleted";

export { StepCompleted };
//# sourceMappingURL=StepCompleted.js.map
